module.exports = __webpack_public_path__ + "static/media/light.0b56ddc3.png";